import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../actions/authAction";
import api from "../utils/api";

// your forceUpdate hook
const useForceUpdate = () => {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
};

const Auth = ({ auth, idp }) => {
  const dispatch = useDispatch();
  const userAuth = useSelector((state) => state.userAuth);

  const login = async () => {
    try {
      // Backend returns the URL to redirect to
      const res = await api.get("/auth/login");

      // Redirect the browser to the URL
      window.location.href = res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const loginOneLogin = async () => {
    try {
      const res = await api.get("/auth/onelogin/login");
      window.location.href = res.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {auth && idp.includes("entraID") ? (
        <>
          <div
            className="btn btn-primary bg-main-2 justify-content-center  login-bg w-100 rounded-0 border-0 "
            onClick={() => {
              login();
            }}
            style={{ backgroundColor: "#085795" }}
          >
            <div className=" d-flex align-items-center w-100 justify-content-center rounded-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-microsoft me-2"
                viewBox="0 0 16 16"
              >
                <path d="M7.462 0H0v7.19h7.462V0zM16 0H8.538v7.19H16V0zM7.462 8.211H0V16h7.462V8.211zm8.538 0H8.538V16H16V8.211z" />
              </svg>
              <span>Sign in</span>
            </div>
          </div>

          {auth && idp.includes("oneLogin") && (
            <>
              <div className="text-center mt-2 text-black">Or Sign in with</div>
              <div
                className="btn btn-primary bg-main-2 justify-content-center  login-bg w-100 rounded-0 border-0 mt-2"
                onClick={() => {
                  loginOneLogin();
                }}
                style={{ backgroundColor: "black" }}
              >
                <div className=" d-flex align-items-center w-100 justify-content-center rounded-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    width="25"
                    height="25"
                    class="bi bi-microsoft me-2"
                    viewBox="0 0 500 500"
                  >
                    <path
                      d="M0 0 C41.09971464 37.07123102 64.07232776 87.07933973 67.51171875 142.1953125 C69.97833509 190.7230778 53.99879757 242.63987022 21.51171875 279.1953125 C20.50818359 280.36126953 20.50818359 280.36126953 19.484375 281.55078125 C17.20868478 284.14854309 14.87676064 286.67848434 12.51171875 289.1953125 C11.72716309 290.0308667 11.72716309 290.0308667 10.92675781 290.88330078 C-24.77478555 328.58177885 -74.83036838 350.85783384 -126.76171875 352.4140625 C-169.47213862 353.22818169 -213.62740034 342.87684903 -248.48828125 317.1953125 C-249.4421875 316.51210938 -250.39609375 315.82890625 -251.37890625 315.125 C-266.48081706 304.09507038 -279.86130483 291.86468108 -291.48828125 277.1953125 C-292.28234375 276.22980469 -293.07640625 275.26429688 -293.89453125 274.26953125 C-314.91784798 248.09017956 -328.36212097 215.23599954 -333.48828125 182.1953125 C-333.60397461 181.47811035 -333.71966797 180.7609082 -333.83886719 180.02197266 C-341.65577971 129.67595297 -328.90653959 75.21420089 -298.90576172 33.98120117 C-297.45234557 32.03695693 -295.97821881 30.11167519 -294.48828125 28.1953125 C-294.05757324 27.63763184 -293.62686523 27.07995117 -293.18310547 26.50537109 C-261.07942278 -14.49735798 -213.62030154 -42.53721676 -161.77441406 -49.15087891 C-102.89406494 -56.05811486 -44.65513982 -39.50935712 0 0 Z "
                      fill="#FEFEFE"
                      transform="translate(357.48828125,72.8046875)"
                    />
                    <path
                      d="M0 0 C1.10774529 -0.005476 1.10774529 -0.005476 2.23786926 -0.01106262 C4.67956517 -0.01917057 7.12059801 -0.00555776 9.56225586 0.0090332 C11.25711568 0.00955173 12.9519761 0.00903432 14.64683533 0.00752258 C18.1985675 0.00761231 21.75007272 0.01804435 25.30175781 0.03613281 C29.86069021 0.05883737 34.41929141 0.05936109 38.97826481 0.05261517 C42.47748269 0.04927856 45.97662467 0.05589913 49.47582817 0.0657444 C51.15719646 0.06960073 52.83857318 0.07074283 54.51994514 0.06915855 C56.86632597 0.06878889 59.21227727 0.08137942 61.55859375 0.09765625 C62.25734619 0.09517883 62.95609863 0.09270142 63.67602539 0.09014893 C68.48585512 0.14356996 68.48585512 0.14356996 70.71459961 2.37231445 C70.96628189 4.73678589 70.96628189 4.73678589 70.96856689 7.76245117 C70.97420654 8.90663513 70.97984619 10.05081909 70.98565674 11.22967529 C70.98160828 12.49104309 70.97755981 13.75241089 70.97338867 15.05200195 C70.97609764 16.3889383 70.97965804 17.72587316 70.98400879 19.06280518 C70.99314636 22.69910574 70.98958295 26.33529315 70.98325062 29.97159576 C70.97819768 33.77167574 70.9828801 37.57174583 70.98602295 41.37182617 C70.98966466 47.75416814 70.98485814 54.13646387 70.9753418 60.51879883 C70.96445684 67.90445855 70.96798227 75.29000786 70.97899461 82.6756649 C70.98806166 89.00945165 70.98935562 95.3432051 70.98411727 101.67699623 C70.98099435 105.46312902 70.980597 109.24920987 70.98719025 113.03533936 C70.99295466 116.59430883 70.98898357 120.15313554 70.97740173 123.71208954 C70.97348239 125.64637555 70.97944851 127.58067359 70.98565674 129.51495361 C70.98001709 130.65913757 70.97437744 131.80332153 70.96856689 132.98217773 C70.96781284 133.98064728 70.96705879 134.97911682 70.96628189 136.00784302 C70.71459961 138.37231445 70.71459961 138.37231445 68.71459961 140.37231445 C66.80368042 140.61282349 66.80368042 140.61282349 64.44848633 140.59936523 C63.5677243 140.59921417 62.68696228 140.59906311 61.7795105 140.59890747 C60.82738678 140.5885849 59.87526306 140.57826233 58.89428711 140.56762695 C57.92049103 140.56479706 56.94669495 140.56196716 55.94338989 140.55905151 C52.82533612 140.54783358 49.70756693 140.52272615 46.58959961 140.49731445 C44.47892667 140.48728673 42.36824923 140.47816052 40.25756836 140.4699707 C35.07648126 140.44788903 29.89556076 140.41439575 24.71459961 140.37231445 C23.07790202 137.09891928 23.58557685 133.48010638 23.60107422 129.88354492 C23.60092819 129.00543152 23.60078217 128.12731812 23.60063171 127.22259521 C23.60133003 124.31153925 23.60911866 121.40054678 23.61694336 118.48950195 C23.61880783 116.47453852 23.62023159 114.45957464 23.62123108 112.4446106 C23.62505399 107.13452916 23.63488237 101.82447496 23.64593506 96.5144043 C23.65615402 91.09855518 23.66072974 85.68270168 23.66577148 80.2668457 C23.67650482 69.6353233 23.69357855 59.00382114 23.71459961 48.37231445 C22.79122803 48.3880249 21.86785645 48.40373535 20.91650391 48.41992188 C17.48920072 48.47106277 14.06230319 48.5086698 10.63476562 48.53710938 C9.15162761 48.55219213 7.66853417 48.57266134 6.18554688 48.59863281 C4.05319216 48.63504061 1.92142726 48.65204518 -0.21118164 48.6652832 C-1.49420166 48.68099365 -2.77722168 48.6967041 -4.09912109 48.71289062 C-7.28540039 48.37231445 -7.28540039 48.37231445 -9.20327759 47.11328125 C-10.52478712 44.98717855 -10.6654254 43.72060988 -10.67358398 41.22387695 C-10.68304047 40.39291504 -10.69249695 39.56195313 -10.70223999 38.70581055 C-10.6961673 37.81200684 -10.6900946 36.91820312 -10.68383789 35.99731445 C-10.68670807 35.07644043 -10.68957825 34.15556641 -10.6925354 33.20678711 C-10.6945767 31.26000351 -10.68904222 29.31319943 -10.67651367 27.36645508 C-10.66046095 24.38356746 -10.67636011 21.40203484 -10.69555664 18.41918945 C-10.69357422 16.52856146 -10.68973057 14.63793431 -10.68383789 12.74731445 C-10.68991058 11.85351074 -10.69598328 10.95970703 -10.70223999 10.03881836 C-10.69278351 9.20785645 -10.68332703 8.37689453 -10.67358398 7.52075195 C-10.6711972 6.79033691 -10.66881042 6.05992187 -10.66635132 5.30737305 C-10.28540039 3.37231445 -10.28540039 3.37231445 -9.21647644 1.63630676 C-6.29567703 -0.2755123 -3.37602906 -0.03703809 0 0 Z "
                      fill="#1C1F2A"
                      transform="translate(182.285400390625,159.627685546875)"
                    />
                  </svg>
                  <span>One Login</span>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div
            className="btn"
            onClick={() => {
              // Detect the idp from session
              dispatch(logout()).then((url) => {
                console.log("test logout url", url);
                window.location.href = url;
              });
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-box-arrow-right text-main logout-btn"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
              />
              <path
                fill-rule="evenodd"
                d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
              />
            </svg>
          </div>
        </>
      )}
    </>
  );
};

export default Auth;
